export default __webpack_public_path__ + "static/media/logo-white.0b4f473d.png";